module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camera",
    attrs: {
      "id": "CAMERA-SWF"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mask_visible),
      expression: "mask_visible"
    }],
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.handleChangeOption
    },
    model: {
      value: (_vm.camera_data),
      callback: function($$v) {
        _vm.camera_data = $$v
      },
      expression: "camera_data"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("直接切换")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 0.15
    }
  }, [_vm._v("快闪(0.15秒)")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 0.5
    }
  }, [_vm._v("中速(0.5秒)")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("稍慢(1秒)")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 2.5
    }
  }, [_vm._v("慢速(2.5秒)")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("很慢(4秒)")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 6
    }
  }, [_vm._v("极慢(6秒)")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 7
    }
  }, [_vm._v("自定义时长")]), _vm._v("   \n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.camera_value),
      expression: "camera_value"
    }],
    staticClass: "custom_input",
    staticStyle: {
      "width": "40px",
      "left": "10px"
    },
    attrs: {
      "type": "text",
      "disabled": _vm.camera_data != '7'
    },
    domProps: {
      "value": (_vm.camera_value)
    },
    on: {
      "keydown": function($event) {
        return _vm.checkKeydown(_vm.camera_value)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.camera_value = $event.target.value
      }, function($event) {
        return _vm.cameraInput()
      }],
      "blur": _vm.handleChangeSliderOption
    }
  }), _vm._v("  "), _c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("秒")])], 1), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 8,
      "disabled": _vm.follow_ids.length == 0 && _vm.follow_alias.length == 0
    }
  }, [_vm._v("镜头跟随"), (_vm.follow_ids.length == 0 && _vm.follow_alias.length == 0) ? _c('span', [_vm._v("：无")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.follow_alias), function(item, index) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.handleChangeCameraOption(item)
        }
      }
    }, [(_vm.camera_follow_res[_vm.follow_ids[index]] != null) ? _c('img', {
      attrs: {
        "src": _vm.camera_follow_res[_vm.follow_ids[index]].thumb
      }
    }) : _vm._e()])
  }), 0)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "group clearfix"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.handleChangeButtonOption
    }
  }, [_c('div', {
    staticClass: "icon-scene_-engagement"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("衔接上一画面")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera_transition"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item text"
  }, [_vm._v("镜头缓动: ")]), _vm._v(" "), _c('el-select', {
    staticClass: "item select",
    attrs: {
      "disabled": !_vm.transition_visible
    },
    on: {
      "change": _vm.handleTransitionChange
    },
    model: {
      value: (_vm.transition),
      callback: function($$v) {
        _vm.transition = $$v
      },
      expression: "transition"
    }
  }, _vm._l((_vm.transitionList), function(item) {
    return _c('el-option', {
      key: item.value,
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), (_vm.platform == 'qt') ? _c('psocket', {
    attrs: {
      "attributes": _vm.attributes,
      "flashvars": _vm.flashvars
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60b0cdbd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Camera/Camera.vue
// module id = 393
// module chunks = 0